// extracted by mini-css-extract-plugin
export default {"root":"SiderTitle_root__-ZIah"};